export default __webpack_public_path__ + "assets/doubleHouse.ca8bd6a0.svg";